<template>
  <div class="sky_wrap">
    <div class="sky_btn">
      <div
        v-for="(item, index) in skyList"
        :key="index"
        :class="activeIndex === index ? 'active' : ''"
        class="sky_item"
        @click="changeIndex(index)"
      >
        {{ item.tit }}
      </div>
    </div>
    <div class="sky_content">
      <div class="content_left">
        <div class="left_tit">{{ skyTitle }}</div>
        <div class="left_icon_wrap">
          <div
            v-for="(item, index) in skyImgList"
            :key="index"
            ref="iconItem"
            class="icon_item"
          >
            <i :class="item.src"></i>
            <span v-html="item.txt"></span>
          </div>
        </div>
        <div
          class="left_btn hidden-xs-only"
          @click="handleToDeomo"
        >获取产品演示</div>
      </div>
      <div class="content_right">
        <img
          :src="skycurrentImg" :style="{width:activeIndex==2?'50%':'80%',height:activeIndex==2?'85%':'auto'}"
          alt=""
        />
        <div
          class="left_btn hidden-sm-and-up"
          @click="handleToDeomo"
        >获取产品演示</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: 0,
      skyTitle:
        '提供充电桩全方位管理服务，涵盖设备监控、故障诊断、支付结算、用户管理等模块。平台对接充电桩数据接口，实时监控运行状态，支持远程故障报警与维护，保障充电桩高效稳定运营。',
      skyImgList: [
        {
          src: '',
          txt: '<span style="font-weight:bold;padding-right:10px;">地图概览</span>实时监控充电桩分布、状态、使用率及故障信息，可视化数据分析，助力高效运营与决策优化。',

        },
        {
          src: '',
          txt: '<span style="font-weight:bold;padding-right:10px;">充电桩管理</span>实时监控状态、使用率与故障，支持智能调度、远程运维及用户管理，提升运营效率，赋能智慧充电网络。',
        },
        {
          src: '',
          txt: '<span style="font-weight:bold;padding-right:10px;">订单管理</span>实现充电订单全流程管理，涵盖生成、监控、计费、支付与数据分析，提升运营效率与用户体验。',
        },
      ],
      skycurrentImg: require('../../assets/htgl.png')
    }
  },
  props: {
    skyList: {
      type: Array,
      default: [],
    },
  },
  methods: {
    changeIndex (index) {
      this.activeIndex = index
      switch (this.activeIndex) {
        case 1:
          this.skyTitle =
            '平台涵盖设备管理模块，用户管理模块，支付与结算模块数据分析与报表模块，远程控制与运维模块。精准运维，数据分析，为充电桩高效运营保驾护航。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">数据可视化</span>充电桩可视化数据系统实时监控状态、分析运营与用户行为，优化效率与决策，赋能智能运营。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">充电桩工作状态</span>实时监控充电桩工作状态，智能调度与故障预警，确保高效稳定运行。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">车流量监控</span>实时监控车流量，优化充电桩布局与调度，提升资源利用率与用户体验',
            },
          ]
          this.skycurrentImg = require('../../assets/img/home/图片2.png')
          break
        case 2:
          this.skyTitle =
            '智能充电小程序集成充电桩查找、扫码充电、支付、预约、充电记录及客服功能，通过实时数据与智能调度，为用户提供便捷、高效的充电体验，同时支持故障上报与账单查询，全面满足新能源车主的充电需求。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">便捷找桩充电</span>实时展示附近充电桩位置与空闲状态，支持一键导航、扫码启动充电，自动计费并兼容多种支付方式。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">订单与服务管理</span>可查询历史充电记录、费用明细及电子账单，支持充电桩预约与排队，提升充电效率。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">个人中心与客服</span>用户可管理个人、车辆及支付信息，领取优惠券，同时支持故障上报与在线客服咨询。',
            },
            // {
            //   src: '',
            //   txt: '<span style="font-weight:bold;padding-right:10px;">预约与排队管理</span>支持充电桩预约，实时查看排队情况，节省用户时间',
            // },
            // {
            //   src: '',
            //   txt: '<span style="font-weight:bold;padding-right:10px;">用户中心</span>管理个人信息、车辆信息、支付方式及优惠券',
            // },
            //   {
            //   src: '',
            //   txt: '<span style="font-weight:bold;padding-right:10px;">故障上报与客服支持</span>提供故障上报入口，实时联系客服解决问题',
            // }
          ]
          this.skycurrentImg = require('../../assets/xcx1.png')
          break
        default:
          this.skyTitle =
            '提供充电桩全方位管理服务，涵盖设备监控、故障诊断、支付结算、用户管理等模块。平台对接充电桩数据接口，实时监控运行状态，支持远程故障报警与维护，保障充电桩高效稳定运营。'
          this.$refs.iconItem.map(v => {
            v.style.width = '90%'
          })
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">地图概览</span>实时监控充电桩分布、状态、使用率及故障信息，可视化数据分析，助力高效运营与决策优化。',

            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">充电桩管理</span>实时监控状态、使用率与故障，支持智能调度、远程运维及用户管理，提升运营效率，赋能智慧充电网络。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">订单管理</span>实现充电订单全流程管理，涵盖生成、监控、计费、支付与数据分析，提升运营效率与用户体验。',
            },
          ]
          this.skycurrentImg = require('../../assets/htgl.png')
          break
      }
    },
    handleToDeomo () {
      this.$router.push('/demo')
    }
  },
}
</script>

<style lang="scss" scoped>
.sky_wrap {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }

  .sky_btn {
    width: 100%;
    display: flex;

    .sky_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 13px;
      }
    }

    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;

      &::before {
        content: "▲";
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }

  .sky_content {
    width: 100%;
    display: flex;
    padding: 30px;
    justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    .content_left {
      width: 40%;
      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .left_tit {
        color: #2d3937;
        font-size: 20px;
        min-height: 90px;
        line-height: 22px;
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          padding: 10px 20px;
          color: #646464;
        }
      }

      .left_icon_wrap {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 30px;
        @media screen and (max-width: 768px) {
          justify-content: center;
        }

        .icon_item {
          width: 90%;
          height: 50px;
          @media screen and (max-width: 768px) {
            height: 50px;
          }

          i {
            color: #7bbde3;
            @media screen and (max-width: 768px) {
              font-size: 20px;
            }
          }

          span {
            color: #646464;
            font-size: 17px;
            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }

      .left_btn {
        width: 150px;
        height: 40px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
      }
    }

    .content_right {
      width: 40%;
      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
      }
      text-align: right;

      img {
        margin-top: 30px;
        width: 80%;
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          width: 120px;
          height: 35px;
          font-size: 14px;
          border-radius: 20px;
          margin: 20px auto;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
